import styles from './styles.module.scss';

const Button = ({ children, variant = 'primary', variantSecondary, className = '', loading = false, ...props }) => (
    <button
        className={`${styles[variant]} ${variantSecondary ? styles[variantSecondary] : ''} ${className}`}
        disabled={loading || props.disabled}
        {...props}
    >
        {loading && <span className={styles.btnSpinner} />}
        {children}
    </button>
);

export default Button;